import React, { useContext, useEffect } from 'react';
import { Routes, Route, Switch, useNavigate, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import ProtectedRoute from './components/helpers/ProtectedRoute';

import Login from './containers/Login';
import Company from './containers/Public/Company';
import Dashboard from './containers/Dashboard';

import AppContext from './context/AppContext';
import SuperAdmin from './containers/SuperAdmin';

import './style.css';
import 'react-toastify/dist/ReactToastify.css';
import { ModalProvider } from './context/ModalContext';
import TabletView from './modals/TabletView';
import TicketOverview from './modals/TicketOverview';
import AddTicketSlider from './modals/AddTicketSlider';
import BetaDashboard, {
	TestBetaDashboard,
} from './containers/Dashboard/BetaDashboard';
import { AppProvider, useApp } from './context/AppContextBeta';

const LogoutHandler = () => {
	const { logout } = useApp();
	const navigate = useNavigate();

	useEffect(() => {
		logout();
		//navigate('/login', { replace: true });
	}, [navigate]);

	return null;
};

const App = () => {
	const { user: localUser } = useApp();
	const isAuthenticated = Boolean(localUser);

	useEffect(() => {
		const loaderElement = document.querySelector('.loader-container');
		loaderElement.remove();
	}, []);

	return (
		<AppProvider>
			<Routes>
				<Route path="/login/*" element={<Login />} />
				<Route path="/logout" element={<LogoutHandler />} />
				<Route path="/c/:id" element={<Company />} />
				<Route
					path="/superadmin/*"
					element={
						<ProtectedRoute role="default:superadmin" fallbackRedirect="/">
							<SuperAdmin />
						</ProtectedRoute>
					}
				/>
				<Route
					path="/*"
					element={
						isAuthenticated ? (
							<BetaDashboard />
						) : (
							<Navigate to="/login" replace />
						)
					}
				/>
			</Routes>
			<ToastContainer autoClose={2000} className="text-xs" hideProgressBar />
		</AppProvider>
	);

	return (
		<>
			<Routes>
				<Route path="/login" component={Login} />
				<Route
					exact
					path="/logout"
					component={() => {
						logout();
						return null;
					}}
				/>
				{/* THIS IS A PUBLIC URL.  ANYTHING HERE IS TO BE TRIPLE CHECKED BEFORE PUSHING.  NO DATA LEAKS */}

				<ProtectedRoute
					path="/c/:id"
					component={Company}
					fallbackComponent={Company}
				/>
				{/* THIS IS A PUBLIC URL.  ANYTHING HERE IS TO BE TRIPLE CHECKED BEFORE PUSHING.  NO DATA LEAKS */}
				{/* TODO: https://app.asana.com/0/1206384867675534/1207698710594836/f */}
				<ProtectedRoute
					path="/r/:id"
					fallbackComponent={() => <div>service report public</div>}
				/>

					<ProtectedRoute path="/*" component={BetaDashboard} />
			</Routes>

			<ToastContainer autoClose={2000} className="text-xs" hideProgressBar />
		</>
	);
};

export default App;
